import React, { useState, FormEvent } from 'react';
import {
    TextInput,
    Button,
    Notification,
    Group,
    Drawer
} from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import axios from 'axios';
import {BackendUrl} from "../../../util/config";

// Interface for props
interface CreateStorageLocationProps {
    organizationId: string; // pass in the organization ID where this location belongs
    onCreated : () => void
}

// We might define a type for the response
interface StorageLocation {
    id: number;
    name: string;
    description: string;
    // ...
}

export const CreateStorageLocation: React.FC<CreateStorageLocationProps> = ({
                                                                                organizationId,
                                                                                onCreated
                                                                            }) => {
    // State to control drawer open/close
    const [opened, setOpened] = useState(false);

    // Form fields
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    // For success/error messages
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    // Loading state (optional)
    const [loading, setLoading] = useState(false);

    // On form submit
    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setSuccessMessage(null);
        setErrorMessage(null);

        // If you have a JWT token, retrieve it here
        const token = localStorage.getItem('jwt'); // or from context, etc.

        try {
            setLoading(true);

            // Construct the body expected by your backend:
            // The server code indicates you pass a StorageLocation object,
            // which includes an Organization object with its ID set.
            const payload = {
                name,
                description,
            };

            // Make the POST request
            await axios.post<StorageLocation>(
                BackendUrl + `/storage-locations?organizationId=${organizationId}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token ? `Bearer ${token}` : '',
                    },
                }
            );

            // If successful, set success message
            setSuccessMessage(`Stellplatz erfolgreich erstellt`);
            // Optionally reset fields
            setName('');
            setDescription('');
            onCreated()

        } catch (err: any) {
            console.error(err);
            setErrorMessage(err?.response?.data?.message || 'Error creating storage location');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* The button that opens the drawer */}
            <Button onClick={() => setOpened(true)} variant={"filled"}>Erstellen</Button>

            {/* Mantine Drawer to hold the form */}
            <Drawer
                opened={opened}
                onClose={() => setOpened(false)}
                title="Erstelle Stellplatz"
                padding="md"
                size="lg"
            >
                {/* The form and notifications within the Drawer */}
                {successMessage && (
                    <Notification
                        icon={<IconCheck size={18} />}
                        color="teal"
                        mb="sm"
                        onClose={() => setSuccessMessage(null)}
                    >
                        {successMessage}
                    </Notification>
                )}
                {errorMessage && (
                    <Notification
                        icon={<IconX size={18} />}
                        color="red"
                        mb="sm"
                        onClose={() => setErrorMessage(null)}
                    >
                        {errorMessage}
                    </Notification>
                )}

                <form onSubmit={handleSubmit}>
                    <TextInput
                        label="Name"
                        placeholder="Bitte gib einen Namen ein"
                        required
                        value={name}
                        onChange={(e) => setName(e.currentTarget.value)}
                        mb="sm"
                    />

                    <TextInput
                        label="Beschreibung"
                        placeholder="Bitte gib eine Beschreibung ein"
                        required
                        value={description}
                        onChange={(e) => setDescription(e.currentTarget.value)}
                        mb="sm"
                    />

                    <Group p="right" mt="md">
                        <Button type="submit" loading={loading}>
                            Erstellen
                        </Button>
                    </Group>
                </form>
            </Drawer>
        </>
    );
};
